import React, {FunctionComponent} from 'react';
import {ProduktGruppe as ProduktGruppeModel} from '@juris/api-gen';
import {ProduktGruppe} from './_Shared';
import {useConfigContext} from 'Context';

interface VertiefungProps {
    themen: Array<ProduktGruppeModel>;
}

export const Vertiefung: FunctionComponent<VertiefungProps> = ({themen}) => {
    const {ergebnis} = useConfigContext();

    return <>
        <section className='cs-textblock content-section'>
            <div className='container'>
                <div className='textblock textblock--text-large'>
                    <h2>{ergebnis.vertiefung.title}</h2>
                    <p dangerouslySetInnerHTML={{__html: ergebnis.vertiefung.text}}/>
                </div>
            </div>
        </section>
        <section className='cs-expertise-container content-section'>
            <div className='expertise-container' data-show-more='alle anzeigen' data-show-less='weniger anzeigen'
                 data-expand-all='alle aufklappen' data-expand-none='alle einklappen'
                 data-load-all='alle Fachgebiete laden' data-load-less='weniger Fachgebiete anzeigen'>
                <div className='container'>
                    <div className='row'>
                        {themen.map((thema, index) => <ProduktGruppe key={index}
                                                                     index={index}
                                                                     produktGruppe={thema}/>)}
                    </div>
                </div>
            </div>
        </section>
    </>;
};